import cloneDeep from 'lodash/cloneDeep';

import { addDays, datesHaveSameDayMonthYear, isAfter } from '~/services/TimeService';

type RangeDate = Date | string;

export interface DateListEntry<TDate extends RangeDate = RangeDate> {
  date: TDate;
}

export interface DateRange<TDate extends RangeDate = RangeDate> {
  start: TDate;
  end: TDate;
}

function dateIsNextFromRange<TDate extends RangeDate>(range: DateRange<TDate>, date: TDate): boolean {
  const nextDayFromRange = addDays(1, cloneDeep(range.end));
  return datesHaveSameDayMonthYear(nextDayFromRange, date);
}

export default function convertDateListToRanges<TDate extends RangeDate>(
  dates: Array<DateListEntry<TDate>>,
): Array<DateRange<TDate>> {
  const sortedDates = dates.sort((a, b) => (isAfter(a.date, b.date) ? 1 : -1));
  const ranges: Array<DateRange<TDate>> = [];

  for (let i = 0; i < sortedDates.length; i++) {
    const last = ranges.length - 1;
    const date = sortedDates[i].date;

    if (ranges.length > 0 && dateIsNextFromRange(ranges[last], date)) {
      ranges[last].end = date;
    } else {
      ranges.push({
        start: date,
        end: date,
      });
    }
  }

  return ranges;
}
